import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function usersDataReducer(state = initialState.usersData, action) {
  switch (action.type) {
    case types.LOAD_USERS_DATA_SUCCESS:
      return action.usersData;
    default:
      return state;
  }
}
